export const PROPS_STEERING_DATA_GUID = "steeringDataGuid";
export const PROPS_NAME = "name";
export const PROPS_LOCATION = "location";
export const PROPS_FILE_NAME = "fileName";
export const PROPS_LAST_MODIFIED = "lastModified";
export const PROPS_SOURCE_TYPE = "sourceType";
export const PROPS_HIERARCHY_LEVELS = "hierarchyLevels";
export const PROPS_NOTES = "notes";
export const PROPS_PUBLIC_URL = "publicUrl";
export const PROPS_CREATED_BY = "createdBy";
export const PROPS_EMBEDDING_STATUS = "embeddingStatus";
